import type { TenantSettings, UserSettings } from '@/stores/auth'
import { apiCall } from './axiosInstance'

export const settingsApi = {
	getUserSettings: async (): Promise<UserSettings> => {
		return apiCall<UserSettings>('/v3/me/settings', {
			method: 'GET',
		})
	},
	updateUserSettings: async (settingBody: {
		settings: UserSettings
	}): Promise<UserSettings> =>
		apiCall('/v3/me/settings', {
			method: 'PUT',
			data: settingBody,
		}),
	updateTenantSettings: async (settingBody: { settings: TenantSettings }): Promise<TenantSettings> =>
		apiCall('/v3/tenant-settings', {
			method: 'PATCH',
			data: settingBody.settings,
		}),
}
